<template>
  <v-btn
    color="blue darken-1 white--text"
    depressed
    class="my-2"
    v-bind="{ ...$attrs, ...$props }"
    v-on="$listeners"
    ><slot
  /></v-btn>
</template>

<script>
export default {
  name: 'BtnBaseBlue',
  components: {},
  props: {},
  data() {
    return {}
  },
}
</script>
